module.exports = __webpack_public_path__ + "img/home1-2.eadf0791.jpg";